/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createTransaction} from '../api'

export const useMutationCreateTransaction = createReactQueryMutationHook('createTransaction', createTransaction)
